// src/services/mainAreaService.js
import api from '../config/axios';

const BASE_PATH = '/main-areas';

// Query Operations
export const getAllMainAreas = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

export const getAllMainAreasPaged = async (page = 0, size = 10, sort = 'nama,asc') => {
  const response = await api.get(`${BASE_PATH}/paged`, {
    params: { page, size, sort }
  });
  return response.data;
};

export const getMainAreaById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export const getMainAreaByNama = async (nama) => {
  const response = await api.get(`${BASE_PATH}/nama/${encodeURIComponent(nama)}`);
  return response.data;
};

export const searchMainAreasByNama = async (query) => {
  const response = await api.get(`${BASE_PATH}/search/nama`, {
    params: { q: query }
  });
  return response.data;
};

export const searchMainAreas = async (filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: {
      nama: filters.nama || undefined,
      ibukota: filters.ibukota || undefined,
      pulau: filters.pulau || undefined,
      page,
      size
    }
  });
  return response.data;
};

// Command Operations
export const createMainArea = async (mainAreaData) => {
  const response = await api.post(BASE_PATH, mainAreaData);
  return response.data;
};

export const updateMainArea = async (id, mainAreaData) => {
  const response = await api.put(`${BASE_PATH}/${id}`, mainAreaData);
  return response.data;
};

export const softDeleteMainArea = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

export const hardDeleteMainArea = async (id) => {
  await api.delete(`${BASE_PATH}/${id}/permanent`, {
    params: { confirm: true }
  });
};

export const restoreMainArea = async (id) => {
  await api.post(`${BASE_PATH}/${id}/restore`);
};

export const cleanupOldDeletedMainAreas = async (daysOld = 90) => {
  const response = await api.delete(`${BASE_PATH}/cleanup`, {
    params: { daysOld, confirm: true }
  });
  return response.data;
};

// Validation Operations
export const checkNama = async (nama) => {
  const response = await api.get(`${BASE_PATH}/check/nama`, {
    params: { nama }
  });
  return response.data.exists;
};

export const getAllIslands = async () => {
  const response = await api.get(`${BASE_PATH}/islands`);
  return response.data.islands;
};

// Statistics Operations
export const getMainAreaStatistics = async () => {
  const response = await api.get(`${BASE_PATH}/statistics`);
  return response.data;
};

export default {
  getAllMainAreas,
  getAllMainAreasPaged,
  getMainAreaById,
  getMainAreaByNama,
  searchMainAreasByNama,
  searchMainAreas,
  createMainArea,
  updateMainArea,
  softDeleteMainArea,
  hardDeleteMainArea,
  restoreMainArea,
  cleanupOldDeletedMainAreas,
  checkNama,
  getAllIslands,
  getMainAreaStatistics
};